/* eslint-disable */

const enumerateArray = (list, currentPage = 1, perPage = 1) => {
  let currentNum = (currentPage - 1) * perPage;

  return list.map((item) => {
    item.num = ++currentNum;
    return item;
  });
};

export default enumerateArray;
